import styled from "styled-components";

export const StyledSortContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;

  --background-hover: transparent;
`;